import xhr from 'xhr';

export default function(cdn, appId) {
  return new Promise((resolve, reject) => {
    xhr.get(`${cdn}/orgs/configs/chat/${appId}.json?q=${new Date().getTime()}`, { json: true }, (err, req) => {
      if (err) {
        reject({
          message: 'could not get configuration',
          error: err,
        });
        return;
      }

      if (req.statusCode < 200 || req.statusCode >= 300) {
        reject({
          message: 'could not get configuration',
          error: new Error(`bad response code: ${req.statusCode}`),
        });
        return;
      }

      resolve(req.body);
    });
  });
}
